import __base_store from '@/store/__base_store'

/**
 * Store de turnos de caja.
 */
export default __base_store({
	state: {
		model_name: 'turno_caja',
	},
})

